module.exports = __webpack_public_path__ + "static/media/paintbrush.c6a0c661.svg";